export default "__VITE_ASSET__e84871f6__"